module.exports = __webpack_public_path__ + "static/img/nav4.82292b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/ios/nav4.png
// module id = agGW
// module chunks = 0